import { Directive, Input } from '@angular/core';

import { DsLoadingSize } from '@type/ds-loading-size.type';
import { DsLoadingTheme } from '@type/ds-loading-theme.type';

@Directive()
export abstract class DsAbstractLoadingComponent {
  /**
   * Controls indicator size. Maps to size tokens unless a component-specific override is set.
   *
   * @default 'md'
   */
  @Input() size: DsLoadingSize = 'md';

  /**
   * Controls indicator color. Use `inherit` to keep the parent color.
   *
   * @default 'brand'
   */
  @Input() theme: DsLoadingTheme = 'brand';

  /**
   * Optional color override. When set, it takes precedence over `theme`.
   */
  @Input() color: string | null = null;

  /**
   * Accessible label announced for the loading state.
   *
   * @default 'Loading'
   */
  @Input() ariaLabel = 'Loading';
}
